<template>
    <div id="app">

        <router-view></router-view>
    </div>
</template>

<script>
import Login from './pages/Login.vue'
import Home from './pages/Home.vue'
export default {
    name: 'App',
    components: { Login, Home }
}
</script>

<style></style>
